export function createWebhookObject(responseObj) {
  return {
    websiteId: responseObj.channelId,
    webhookId: responseObj.hookId,
    webhookAddress: responseObj.hook.callBackUrl,
    enabled: convertStatusToEnabled(responseObj.hook.isGivenUp),
    token: responseObj.hook.token ?? '',
    new_message_event: responseObj.events.includes('new_message'),
    new_chat_event: responseObj.events.includes('new_chat'),
  };
}

// converts returned status code from API to 'enabled'
export function convertStatusToEnabled(status) {
  const enabled = status === true ? false : true;
  return enabled;
}

export function createWebhooksObject(responseObj) {
  return responseObj.map((item) => createWebhookObject(item));
}

export function createApiObject(webhookObj, mode) {
  const obj = { events: [] };
  const token = webhookObj.token?.trim();

  const events = {
    new_message_event: 'new_message',
    new_chat_event: 'new_chat',
  };

  for (let event of Object.keys(events)) {
    if (webhookObj[event]) {
      obj.events.push(events[event]);
    }
  }

  if ((mode === 'add' && token !== '') || mode === 'edit') {
    obj.token = token;
  }

  obj.channelId = webhookObj.websiteId;
  obj.callBackUrl = webhookObj.webhookAddress.trim();

  return obj;
}

export const getWebhookStatus = (status, locale) => {
  if (locale === 'en') return `Webhook ${status}`;

  return `وب‌هوک  ${status} شد`;
};
